var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"gl-px-3 gl-py-2 gl-transition-medium",attrs:{"to":"/"}},[_c('img',{attrs:{"src":_vm.MaybachLogoSVG,"alt":"Maybach Systems"}})])}
var staticRenderFns = []

export { render, staticRenderFns }